import FilterList from "@mui/icons-material/FilterList";
import ViewColumn from "@mui/icons-material/ViewColumn";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";

import { CommandButton } from "./CommandButton";

type ToolbarButtonProps = {
  /**
   * Render the icon alone instead of the labelled button. The label still
   * reaches screen readers — and Playwright's `getByRole("button", { name })` —
   * through `aria-label`, so the accessible name is the same either way.
   */
  iconOnly?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

/** The grid toolbar's Filters command. */
export const ToolbarFilterButton: React.FC<ToolbarButtonProps> = ({ iconOnly, onClick }) => {
  if (iconOnly) {
    return (
      <Tooltip title="Filters">
        <IconButton size="medium" color="info" aria-label="Filters" onClick={onClick}>
          <FilterList />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <CommandButton onClick={onClick}>
      <FilterList sx={{ mr: 1 }} fontSize="small" />
      Filters
    </CommandButton>
  );
};

/** The grid toolbar's Manage Columns command. */
export const ToolbarManageColumnsButton: React.FC<ToolbarButtonProps> = ({ iconOnly, onClick }) => {
  if (iconOnly) {
    return (
      <Tooltip title="Manage Columns">
        <IconButton size="medium" color="info" aria-label="Manage Columns" onClick={onClick}>
          <ViewColumn />
        </IconButton>
      </Tooltip>
    );
  }
  return <CommandButton onClick={onClick}>Manage Columns</CommandButton>;
};
